<div class="grid sm:grid-cols-4 gap-6 w-full max-w-200">
    <div class="sm:col-span-2">
        <div class="flex-auto cursor-pointer">
            <div class="leading-6 font-semibold">Format numerowania</div>
            <div class="text-md text-secondary">
                Ustaw domyślny format numerowania dokumentów.<br/>
                MM oznacza miesiąc, YYYY oznacza rok.
            </div>
            <div class="text-md text-red-600" *ngIf="isConfigInvalid()">
                Nieprawidłowa konfiguracja. Nie można mieć numerowania miesięcznego i wybranego formatu, ponieważ numer dokumentu nie będzie unikalny. Zmień format na taki, który zawiera miesiąć 'MM'.
            </div>
        </div>
    </div>
    <div class="sm:col-span-2">
        <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
            <mat-select [formControl]="control" matInput>
                <mat-option [disabled]="isDisabled(format)" [matTooltip]="isDisabled(format) ? 'Format jest niedostępny w miesięcznym typie numerowania.' : ''" [value]="format.format" *ngFor="let format of formats">
                    {{format.displayFormat}}  <span class="ml-4">({{formatSample(format.displayFormat)}})</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>